<template>
  <div class="status-description">
    <div class="title" :class="status">
      <slot name="title"> {{ title }}</slot>
    </div>
    <div class="header">
      <slot name="header">{{ statusHeader }}</slot>
    </div>
    <div class="description">
      <div v-if="statusDescriptionHtml && !statusDescription" v-html="statusDescriptionHtml"></div>
      <slot name="description">
        <p>{{ statusDescription }}</p>
      </slot>
      <slot></slot>
      <NextButton
        text="View Certification Updates"
        v-if="statusHeader === titleDictionary[TimelineMilestoneIds.SCHOOL_CERTIFICATION]"
        @click.prevent="emit('viewCertificationUpdates')"
				id="view-certification-updates-btn"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  TimelineMilestone,
  TimelineMilestoneIds,
  titleDictionary,
} from "@/models/applicationStatus";
import { computed } from "vue";
import { useStore } from "vuex";
import NextButton from "@/components/shared/NextButton.vue";

const store = useStore();

const props = defineProps({
  step: {
    type: Number,
  },
  status: {
    type: String,
  },
  mobile: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emit = defineEmits<{
  (e: "viewCertificationUpdates"): void;
}>();

const statuses = computed<TimelineMilestone[]>(() => {
  return store.state.applicationStatusModule.timeline;
});

const title = computed(() => {
  switch (props.status) {
    case "active":
      return "Current Step";
    case "complete":
      return "Completed";
    default:
      return "";
  }
});

const statusHeader = computed<string>(
  () => statuses.value.find((t: TimelineMilestone) => t.step === props.step)?.title || "",
);

const statusDescription = computed<string>(
  () => statuses.value.find((t: TimelineMilestone) => t.step === props.step)?.description || "",
);

const statusDescriptionHtml = computed<string>(() => {
  const step = statuses.value.find((t: TimelineMilestone) => t.step === props.step);

  return step?.html || step?.descriptionHtml || "";
});
</script>

<style scoped>
.status-wrapper .status-description {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  padding-top: 0;
}

.status-wrapper .status-description .header,
.header {
  font-weight: var(--font-weight-bold);
  margin-bottom: 0;
  font-family: var(--header-font);
  color: #000;
}

.status-wrapper .status-description .title,
.title {
  color: var(--theme-color);
  text-transform: uppercase;
  font-size: 0.625rem;
  font-family: var(--header-font);
  font-weight: var(--font-weight-bold);
}

.status-wrapper .status-description .title.complete,
.title.complete {
  color: #008000;
}

.status-wrapper .status-description .description {
  font-size: 0.875rem;
  font-family: var(--header-font);
  line-height: 17.175px;
}

.status-wrapper .status-description.mobile {
  display: none;
  padding: 0;
}

#view-certification-updates-btn {
	display: none;
}
@media (max-width: 1210px) {
  .status-wrapper .status-description:not(.mobile) {
    display: none;
  }
  .status-wrapper .status-description.mobile {
    display: block;
  }
  .divider {
    display: none;
  }
}

@media (max-width: 992px) {
	#view-certification-updates-btn {
		display: block;
	}
}
</style>
